import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {
    getAmplitudeListingFiltersAppliedEventProperties,
    IGetAmplitudeListingFiltersAppliedParams
} from "./get_amplitude_listing_filters_applied_event_properties";

export const trackAmplitudeListingFiltersApplied = (params: IGetAmplitudeListingFiltersAppliedParams) => {
    trackAmplitudeEvent("listing_filters_applied", getAmplitudeListingFiltersAppliedEventProperties(params));
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {
    getAmplitudeListingFiltersAppliedEventProperties,
    IGetAmplitudeListingFiltersAppliedParams
} from "./get_amplitude_listing_filters_applied_event_properties";

export const trackAmplitudeListingFiltersApplied = (params: IGetAmplitudeListingFiltersAppliedParams) => {
    trackAmplitudeEvent("listing_filters_applied", getAmplitudeListingFiltersAppliedEventProperties(params));
};
